import React, { forwardRef } from "react";
import SelectOption from "../../../../../../components/SelectOption";
import { useApi } from "../../../../../../hooks/http2";
import { URL_API, _ } from "../../../../../../utils";

const SelectVatRefund = (props) => {
  const list = useApi(
    {
      url: `${URL_API}/system/master/vat_refund `,
      token: true,
    },
    []
  );
  return (
    <SelectOption
    loading={list.loading}
    data={_.map(list.fetch?.data || [], (n) => ({
      value: parseInt(n.code),
      text: n.name,
    }))}
    {...props}
    />
    
  );
};

export default forwardRef((props, ref) => {
  return <SelectVatRefund forwardRef={ref} {...props} />;
});
